const RRP_FOOTNOTE_ROUTES = new Set([
  "/[slug]",
  "/[slug]/[category]",
  "/[slug]/sale",
  "/[slug]/hot-deals",
  "/[slug]/products",
  "/[slug]/new",
  "/[slug]/designer",
  "/[slug]/designers",
  "/[slug]/collections/[...collectionSlug]",
  "/products",
  "/products/[category]",
  "/brands/[...slug]",
  "/product/[productSlug]",
  "/search/[[...gender]]",
  "/favourites",
  "/cart",
]);

function showsRRPFootnote(route: string): boolean {
  return RRP_FOOTNOTE_ROUTES.has(route);
}

export { RRP_FOOTNOTE_ROUTES, showsRRPFootnote };
